<template>
  <div class="margin-top-48">
    <div class="grid-column ai-c jc-s gap-16">
      <div class="sac__font-32 f-white semi-bold">
        {{ header }}
      </div>
      <button
        type="button"
        @click="toggleBlock"
      >
        <img
          v-if="showGraph"
          src="@shared/assets/img/service/chevron-up.svg"
          class="img-size-12"
          alt="Edit"
        >
        <img
          v-else
          src="@shared/assets/img/service/white-chev-down.svg"
          class="img-size-12"
          alt="Edit"
        >
      </button>
    </div>
    <div :class="[`collapsable-container-${className}`]" :style="{ height: containerHeight }">
      <div v-if="alertList.length">
        <div
          v-for="(item, idx) in alertList"
          :key="idx"
        >
          <div class="alert-info-card">
            <LeadTitleInfo
              :alert="item.alert"
              :hideDismiss="hideDismiss"
              :hideExport="hideExport"
            />
            <div class="grid-column even ai-s gap-24">
              <AlertInstanceList
                :alert="item.alert"
                :alertList="item.alertList"
                :cycleList="item.alertCycleList"
              />
              <fragment>
                <AreaGraph
                  v-if=" (item.alert.alertGroup === 'Cooling'
                    || item.alert.alertGroup === 'Heating'
                    || item.alert.alertGroup === 'Freeze')"
                  :alertDetail="item"
                />
                <RuntimeGraph
                  v-else-if="item.alert.alertGroup === 'Runtime' && item.alert.type.includes('Runtime')"
                  :alertDetail="item"
                />
                <WaterLeakGraph
                  v-else-if="item.alert.alertGroup === 'Leaks'"
                  :alertDetail="item"
                />
              </fragment>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-data-container bg-n90 margin-top-16">
        No data available..
      </div>
    </div>
  </div>
</template>
<script>
import RuntimeGraph from '@shared/components/service/leadDetail/graphs/RuntimeGraph.vue';
import WaterLeakGraph from './graphs/WaterLeakGraph.vue';
import AreaGraph from './graphs/AreaGraph.vue';
import LeadTitleInfo from './LeadTitleInfo.vue';
import AlertInstanceList from './AlertInstanceList.vue';

export default {
  name: 'ActiveAlertsList',
  components: {
    RuntimeGraph,
    LeadTitleInfo,
    AlertInstanceList,
    AreaGraph,
    WaterLeakGraph,
  },
  props: {
    className: String,
    header: String,
    alertList: Array,
    hideDismiss: Boolean,
    hideExport: Boolean,
  },
  data() {
    return {
      showGraph: false,
      containerHeight: 'auto',
    };
  },
  methods: {
    toggleBlock() {
      const firstData = document.querySelector(`.collapsable-container-${this.className}`);

      if (firstData.clientHeight) {
        this.containerHeight = '0';
        this.showGraph = false;
      } else {
        this.containerHeight = 'auto';
        this.showGraph = true;
      }
    },
  },
};
</script>

<style lang="scss">
.alert-info-card {
  padding: 16px;
  background-color: $N90;
  border-radius: 8px;
  display: grid;
  gap: 16px;
  height: 370px;
  margin-top: 1rem;
}
.collapsable-container-urgent, .collapsable-container-watching {
  transition: height 200ms;
  overflow: hidden;
}
</style>
